import useBreakpoint from './useBreakpoint';

const useIsMobile = () => {
  const breakpoint = useBreakpoint();

  return ['xs', 'sm'].includes(breakpoint);
};

export default useIsMobile;
